export default {
      id: "pay_sber-usage",
      viewBox: "0 0 48 24",
      url: __webpack_public_path__ + "sprite.svg#pay_sber",
      toString: function () {
        return this.url;
      }
    }